import { Modal, Button, Radio } from "antd";

const SMPrintTemplateModal = ({
  showPrintTemplateModal,
  selectedPrintTemplate,
  setSelectedPrintTemplate,
  handlePrintTemplateCancel,
  handlePrintTemplateConfirm,
  printTemplates,
}) => {
  return (
    <Modal
      open={showPrintTemplateModal}
      title={<span style={{ fontSize: "16px", fontWeight: 600, color: "#1f1f1f" }}>Select Receipt Template</span>}
      onCancel={handlePrintTemplateCancel}
      footer={
        <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
          <Button
            style={{
              height: "36px",
              borderRadius: "6px",
              fontSize: "14px",
              fontWeight: 500,
              border: "1px solid #d9d9d9",
              color: "#333",
              padding: "0 20px",
            }}
            onClick={handlePrintTemplateCancel}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            style={{
              height: "36px",
              borderRadius: "6px",
              fontSize: "14px",
              fontWeight: 500,
              backgroundColor: "#2d3748",
              borderColor: "#2d3748",
              padding: "0 20px",
            }}
            onClick={handlePrintTemplateConfirm}
            disabled={!selectedPrintTemplate}
          >
            Print Receipt
          </Button>
        </div>
      }
      centered
      width={480}
      styles={{ body: { padding: "16px 24px", maxHeight: "400px", overflowY: "auto" } }}
      maskClosable={false}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <Radio.Group
          value={selectedPrintTemplate}
          onChange={(e) => {
            setSelectedPrintTemplate(e.target.value);
          }}
          style={{ width: "100%" }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {printTemplates.map((template) => (
              <div
                key={template.cwr_printtemplate_id}
                style={{
                  border: selectedPrintTemplate === template.cwr_printtemplate_id ? "1px solid #2d3748" : "1px solid #e8e8e8",
                  borderRadius: "6px",
                  padding: "12px 14px",
                  cursor: "pointer",
                  backgroundColor: selectedPrintTemplate === template.cwr_printtemplate_id ? "#f7fafc" : "#fff",
                  transition: "all 0.2s ease",
                }}
                onClick={() => {
                  setSelectedPrintTemplate(template.cwr_printtemplate_id);
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <Radio value={template.cwr_printtemplate_id} />
                  <span style={{ fontWeight: 500, fontSize: "14px", color: "#1f1f1f" }}>{template.name}</span>
                </div>
              </div>
            ))}
          </div>
        </Radio.Group>
      </div>
    </Modal>
  );
};

export default SMPrintTemplateModal;
